import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { VoucherFilterControls, type VoucherSortOrder } from '@/components/vouchers/VoucherFilterControls';
import React from 'react';

export type VoucherStatusFilter = 'all' | 'ACTIVE' | 'REDEEMED';

type MyVoucherFilterBarProps = {
  selectedCategory: string;
  searchQuery: string;
  voucherType: 'activated' | 'bookmarked';
  selectedStatus: VoucherStatusFilter;
  onCategoryChange: (category: string) => void;
  onSearchChange: (query: string) => void;
  sortOrder: VoucherSortOrder;
  onSortChange?: (order: VoucherSortOrder) => void;
  onVoucherTypeChange: (type: 'activated' | 'bookmarked') => void;
  onStatusChange: (status: VoucherStatusFilter) => void;
};

export const MyVoucherFilterBar: React.FC<MyVoucherFilterBarProps> = ({
  selectedCategory,
  searchQuery,
  voucherType,
  selectedStatus,
  onCategoryChange,
  onSearchChange,
  sortOrder,
  onSortChange,
  onVoucherTypeChange,
  onStatusChange,
}) => {
  const handleVoucherTypeToggle = (checked: boolean) => {
    // When checked (true) = "Vorgemerkt" (bookmarked)
    // When unchecked (false) = "Aktiviert" (activated)
    onVoucherTypeChange(checked ? 'bookmarked' : 'activated');
  };

  const handleStatusTabChange = (value: string) => {
    onStatusChange(value as VoucherStatusFilter);
  };

  return (
    <div className='space-y-4'>
      {/* Toggle switch for Aktiviert vs Vorgemerkt */}
      <div className='flex items-center justify-between flex-wrap gap-4'>
        <div className='flex items-center space-x-4'>
          <Label htmlFor='voucher-type-switch' className='text-sm font-medium'>
            Aktiviert
          </Label>
          <Switch
            id='voucher-type-switch'
            checked={voucherType === 'bookmarked'}
            onCheckedChange={handleVoucherTypeToggle}
          />
          <Label htmlFor='voucher-type-switch' className='text-sm font-medium'>
            Vorgemerkt
          </Label>
        </div>

        {/* Status filter pills */}
        {voucherType === 'activated' && (
          <div className='flex items-center gap-2'>
            <span className='text-sm font-medium text-muted-foreground'>Status:</span>
            <Tabs value={selectedStatus} onValueChange={handleStatusTabChange} className='flex-1'>
              <TabsList className='bg-swd-hellblau'>
                <TabsTrigger value='all' className='text-sm leading-5'>
                  Alle
                </TabsTrigger>
                <TabsTrigger value='ACTIVE' className='text-sm leading-5'>
                  Aktiv
                </TabsTrigger>
                <TabsTrigger value='REDEEMED' className='text-sm leading-5'>
                  Eingelöst
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
        )}
      </div>

      <VoucherFilterControls
        selectedCategory={selectedCategory}
        searchQuery={searchQuery}
        onCategoryChange={onCategoryChange}
        onSearchChange={onSearchChange}
        sortOrder={sortOrder}
        onSortChange={onSortChange}
      />
    </div>
  );
};
